angular.module('zc.commonApi')

.factory 'ProjectUser', ($resource, $q, BaseProjectCrudService) ->
  class ProjectUser extends BaseProjectCrudService

  new ProjectUser(
    $resource
    $q
    '/api/projects/:projectId/users/:id'
    'user'
    'users'
  )





// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/user.service.coffee